module.exports = __webpack_public_path__ + "static/media/icon-award3.007abf31.svg";